export default "__VITE_ASSET__bb05b9af__"